export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'LocationMaster';
export const NAME = 'LocationMaster';
